import { useCallback, useState } from 'react';

const storageKeyFor = (scope) => `dashboard.amountsVisible.${scope}`;

/**
 * Persist whether dashboard monetary metric cards are visible.
 * @param {'admin' | 'vendor'} scope
 */
export default function useDashboardAmountVisibility(scope = 'admin') {
  const key = storageKeyFor(scope);
  const [amountsVisible, setAmountsVisible] = useState(() => {
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return true;
      return raw !== '0' && raw !== 'false';
    } catch {
      return true;
    }
  });

  const toggleAmountsVisible = useCallback(() => {
    setAmountsVisible((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(key, next ? '1' : '0');
      } catch {
        /* ignore */
      }
      return next;
    });
  }, [key]);

  return { amountsVisible, setAmountsVisible, toggleAmountsVisible };
}
